<template>
  <!-- exhibition-company-brand .ecb -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>企业中心</BreadcrumbItem>
          <BreadcrumbItem>账户安全</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">CMEF展商账户安全设置中心</div>
      </div>
    </div>
    <div class="account-content" v-if="adminInfo">
      <div class="account-content-info">
        <div class="account-content-info-info1">
          <div>
            <p>更换绑定手机号</p>
            <span v-if="adminInfo.phoneNumber"
              >已绑定手机号 {{ adminInfo.phoneNumber || "" }}</span
            >
          </div>
          <Button type="primary" style="width: 96px; height: 32px" @click="add = true"
            >更换手机号</Button
          >
        </div>
        <div class="account-content-info-info1" v-if="false">
          <div>
            <p>更换绑定微信</p>
            <span v-if="adminInfo.wechat">已绑定微信 {{ adminInfo.wechat }}</span>
          </div>
          <Button type="primary" style="width: 96px; height: 32px">更换微信</Button>
        </div>
        <div class="account-content-info-info1">
          <div>
            <p>更换绑定邮箱</p>
            <span v-if="adminInfo.email"> {{ adminInfo.email }}</span>
          </div>
          <Button type="primary" style="width: 96px; height: 32px" @click="add2 = true"
            >更换邮箱</Button
          >
        </div>
        <div class="account-content-info-info1">
          <div>
            <p>修改账户密码</p>
          </div>
          <Button type="primary" style="width: 96px; height: 32px" @click="add3 = true"
            >修改密码</Button
          >
        </div>
      </div>
    </div>
    <div class="u-empty" v-else>暂无数据</div>
    <Contact />
    <changePhone :show="add" @finish="init()" @close="add = false" />
    <changeEmail :show="add2" @finish="init()" @close="add2 = false" />
    <changePassword :show="add3" @finish="init()" @close="add3 = false" />
  </div>
</template>

<script>
import Contact from "@components/Contact/Contact";
import changePhone from "./components/changePhone";
import changeEmail from "./components/changeEmail";
import changePassword from "./components/changePassword";
import { mapActions, mapGetters } from "vuex";

export default {
  // 账户安全
  name: "company-account",
  data() {
    return {
      add: false,
      add2: false,
      add3: false,
      formValidate: {
        name: "",
        job: "",
        tel: "",
        email: "",
        weixin: "",
      },
      adminInfo: null, // 管理员信息
    };
  },
  components: {
    Contact,
    changePhone,
    changeEmail,
    changePassword,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
    }),
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 账户安全";
    this.init();
  },
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",
    }),
    async init() {
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach((c) => {
        if (c.userId === this.user.id) {
          this.adminInfo = c;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.account-content {
  width: 100%;
  height: auto;
  background-color: #f0f2f5;
  padding: 25px;
  &-info {
    min-width: 800px;
    background-color: #fff;
    &-info1 {
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px 0 45px;
      div {
        display: flex;
        align-items: center;
        p {
          font-size: 16px;
          font-weight: bold;
        }
        span {
          font-size: 14px;
          color: #8c8c8c;
          margin-left: 30px;
        }
      }
    }
  }
}
.account-add {
  padding-top: 20px;
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
  }
}
</style>
